import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_1a84675c from 'nuxt_plugin_plugin_1a84675c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_hotjar_5d46f7f8 from 'nuxt_plugin_hotjar_5d46f7f8' // Source: ./hotjar.js (mode: 'client')
import nuxt_plugin_gtm_dfaa1070 from 'nuxt_plugin_gtm_dfaa1070' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_db3c871c from 'nuxt_plugin_axios_db3c871c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_5fef8fcc from 'nuxt_plugin_cookieuniversalnuxt_5fef8fcc' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_3a8ae409 from 'nuxt_plugin_pluginutils_3a8ae409' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_79629314 from 'nuxt_plugin_pluginrouting_79629314' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_29c150db from 'nuxt_plugin_pluginmain_29c150db' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_wordpress_608f9073 from 'nuxt_plugin_wordpress_608f9073' // Source: ../plugins/wordpress (mode: 'all')
import nuxt_plugin_woocommerce_193ab6ec from 'nuxt_plugin_woocommerce_193ab6ec' // Source: ../plugins/woocommerce (mode: 'all')
import nuxt_plugin_bolev_5e74feac from 'nuxt_plugin_bolev_5e74feac' // Source: ../plugins/bolev (mode: 'all')
import nuxt_plugin_persistedStateclient_6eed11fc from 'nuxt_plugin_persistedStateclient_6eed11fc' // Source: ../plugins/persistedState.client.js (mode: 'client')
import nuxt_plugin_vClickOutsideclient_2f7dd82b from 'nuxt_plugin_vClickOutsideclient_2f7dd82b' // Source: ../plugins/vClickOutside.client.js (mode: 'client')
import nuxt_plugin_vClickOutside2client_45dedee3 from 'nuxt_plugin_vClickOutside2client_45dedee3' // Source: ../plugins/vClickOutside2.client.js (mode: 'client')
import nuxt_plugin_geolocalisationclient_5acb01a9 from 'nuxt_plugin_geolocalisationclient_5acb01a9' // Source: ../plugins/geolocalisation.client.js (mode: 'client')
import nuxt_plugin_intersectclient_632cb8b7 from 'nuxt_plugin_intersectclient_632cb8b7' // Source: ../plugins/intersect.client.js (mode: 'client')
import nuxt_plugin_seo_55574652 from 'nuxt_plugin_seo_55574652' // Source: ../plugins/seo (mode: 'all')
import nuxt_plugin_animateScrollclient_7f1540e6 from 'nuxt_plugin_animateScrollclient_7f1540e6' // Source: ../plugins/animateScroll.client.js (mode: 'client')
import nuxt_plugin_gdata_b1c348e8 from 'nuxt_plugin_gdata_b1c348e8' // Source: ../plugins/gdata.js (mode: 'all')
import nuxt_plugin_hreflangglobal_7dd3f2f4 from 'nuxt_plugin_hreflangglobal_7dd3f2f4' // Source: ../plugins/hreflang-global.js (mode: 'all')
import nuxt_plugin_gtminitclient_35bcf531 from 'nuxt_plugin_gtminitclient_35bcf531' // Source: ../plugins/gtm-init.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Lev","htmlAttrs":{"lang":"pt"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"theme-color-dark","name":"theme-color","content":"FFFEF8","media":"(prefers-color-scheme: dark)"},{"hid":"theme-color-light","name":"theme-color","content":"FFFEF8","media":"(prefers-color-scheme: light)"},{"hid":"og_type","name":"og_type","content":"article"},{"hid":"og_locale","name":"og_locale","content":"pt_PT"},{"name":"p:domain_verify","content":"abcd5ceb0bf5c6c8eac3faf66745ab59"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Inter:wght@300;400;500;600;700&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Inter:wght@300;400;500;600;700&display=swap"},{"rel":"preconnect","href":"https:\u002F\u002Fbo.lev.pt","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Flevcms.live.afonso.se","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Flevcms.live.afonso.se"},{"rel":"preconnect","href":"https:\u002F\u002Fin.hotjar.com"},{"rel":"preconnect","href":"https:\u002F\u002Fstats.g.doubleclick.net"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-WBF2RRM&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_1a84675c === 'function') {
    await nuxt_plugin_plugin_1a84675c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hotjar_5d46f7f8 === 'function') {
    await nuxt_plugin_hotjar_5d46f7f8(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_dfaa1070 === 'function') {
    await nuxt_plugin_gtm_dfaa1070(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_db3c871c === 'function') {
    await nuxt_plugin_axios_db3c871c(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_5fef8fcc === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_5fef8fcc(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_3a8ae409 === 'function') {
    await nuxt_plugin_pluginutils_3a8ae409(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_79629314 === 'function') {
    await nuxt_plugin_pluginrouting_79629314(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_29c150db === 'function') {
    await nuxt_plugin_pluginmain_29c150db(app.context, inject)
  }

  if (typeof nuxt_plugin_wordpress_608f9073 === 'function') {
    await nuxt_plugin_wordpress_608f9073(app.context, inject)
  }

  if (typeof nuxt_plugin_woocommerce_193ab6ec === 'function') {
    await nuxt_plugin_woocommerce_193ab6ec(app.context, inject)
  }

  if (typeof nuxt_plugin_bolev_5e74feac === 'function') {
    await nuxt_plugin_bolev_5e74feac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_persistedStateclient_6eed11fc === 'function') {
    await nuxt_plugin_persistedStateclient_6eed11fc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vClickOutsideclient_2f7dd82b === 'function') {
    await nuxt_plugin_vClickOutsideclient_2f7dd82b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vClickOutside2client_45dedee3 === 'function') {
    await nuxt_plugin_vClickOutside2client_45dedee3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_geolocalisationclient_5acb01a9 === 'function') {
    await nuxt_plugin_geolocalisationclient_5acb01a9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_intersectclient_632cb8b7 === 'function') {
    await nuxt_plugin_intersectclient_632cb8b7(app.context, inject)
  }

  if (typeof nuxt_plugin_seo_55574652 === 'function') {
    await nuxt_plugin_seo_55574652(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_animateScrollclient_7f1540e6 === 'function') {
    await nuxt_plugin_animateScrollclient_7f1540e6(app.context, inject)
  }

  if (typeof nuxt_plugin_gdata_b1c348e8 === 'function') {
    await nuxt_plugin_gdata_b1c348e8(app.context, inject)
  }

  if (typeof nuxt_plugin_hreflangglobal_7dd3f2f4 === 'function') {
    await nuxt_plugin_hreflangglobal_7dd3f2f4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtminitclient_35bcf531 === 'function') {
    await nuxt_plugin_gtminitclient_35bcf531(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
